import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        "AboutUs": "About Us",
        "AboutUsTitle": "Allah Helps Those Who Help Themselves",
        "AboutUsContent": "Al-Infaaq Trust was established in 2016 with the aim of identifying economically backward families in society and providing them with the necessary support. What started with a single family has now grown to assist over 30 families.",
        "OurMission": "Our Mission",
        "Mission1": "Providing <b>essential assistance</b> to underprivileged families.",
        "Mission2": "Empowering women with <b>self-employment training</b> and <b>job opportunities</b>.",
        "Mission3": "Offering <b>IT education</b> and training programs to students.",
        "ReadMore": "Read More ▶",
        "Notices": "Notices",
        "TailoringCourse": "👗 Tailoring Course",
        "EmbroideryCourse": "🧵 Embroidery & Aari Work",
        "SoftwareCourse": "💻 Software Development Course",
        "OngoingRegistrations": "Ongoing Registrations",
        "TailoringDetails": "Learn professional tailoring skills with hands-on training.",
        "EmbroideryDetails": "Master embroidery and aari work techniques for traditional designs.",
        "SoftwareDetails": "Full-stack development training in React, Node.js, and databases.",
        "services_support": "Services and Support",
        "monthly_essentials": "Monthly Essential Items",
        "monthly_essentials_desc": "We provide grocery essentials to more than 30+ families every month.",
        "medical_education_fund": "Medical & Education Assistance",
        "medical_education_fund_desc": "We support families with emergency medical expenses, educational assistance, and scholarships for students.",
        "self_employment_support": "Self-Employment Support",
        "self_employment_support_desc": "We help families start their own businesses and assist with government welfare schemes.",
        "scholarship_assistance": "Scholarship Assistance",
        "scholarship_assistance_desc": "We conduct camps to help students apply for government and private scholarships.",
        /***about us page */
        "about_us": "About Us",
        "a_little_insight": "A little insight",
        "about_us_heading": "A little insight about us.",
        "about_us_content": "Al-Infaaq Trust was established in 2016 with the goal of identifying economically disadvantaged families in society and providing them with the necessary assistance. What started with just one family has now grown to support over 30 families.",
        "our_mission": "Our Mission",
        "mission_1": "Providing essential aid to underprivileged families.",
        "mission_2": "Creating self-employment training and job opportunities for women.",
        "mission_3": "Offering IT education and training for students.",
        "activity": "Activity",
        "family_assistance": "Family Assistance",
        "education": "Education",
        "housing": "Housing",
        "social_help": "Social Assistance",
        "vocational_training": "Vocational Training",
        "donation": "Donation",
        "activity_description": "{{activity}} is provided to those in need.",
        "elevate_lives": "Elevate Lives, Build a Better Future",
        "donate_today": "Donate Today!",
        "donate_now": "Donate Now",
        /**course */
        "courses": {
          "heading": "SKILL DEVELOPMENT COURSES",
          "subheading": "Our Free Training & Educational Courses",
          "register": "Register Now",
          "tailoring": {
            "title": "Tailoring Training",
            "description": "This training teaches sewing skills to women, serving as a foundation for self-employment. These classes help women engage in self-employment with confidence."
          },
          "embroidery": {
            "title": "Embroidery & Aari Work Training",
            "description": "Develop skills in embroidery and Aari work, providing a great opportunity for women to become entrepreneurs and gain confidence."
          },
          "software": {
            "title": "Software Course Training",
            "description": "Basic & advanced computer training for students and youth, helping them progress in the technology world, gain skills, and create job opportunities."
          },
        },
        /**service */
        "services_support": "Services & Support",
        "monthly_essentials": "Monthly Essential Supplies",
        "monthly_essentials_desc": "Supporting 30+ families every month with essential groceries and supplies.",
          "helping_the_needy": "Helping the Needy",
    "helping_the_needy_desc": "Assisting widows, elderly, unemployed individuals, chronically ill patients, accident victims, and mentally challenged individuals.",
        "medical_education_fund": "Medical & Educational Aid",
        "medical_education_fund_desc": "Providing emergency medical expenses, educational support, and scholarships for students.",
        "self_employment_support": "Self-Employment Support",
        "self_employment_support_desc": "Encouraging self-employment by setting up small businesses and guiding people to apply for government welfare schemes.",
        "scholarship_assistance": "Scholarship Assistance",
        "scholarship_assistance_desc": "Organizing camps to help students apply for government and private scholarships.",
        "government_welfare_awareness": "Government Welfare Awareness",
    "government_welfare_awareness_desc": "Conducting awareness programs and helping people apply for government welfare schemes online.",
    "free_tailoring_training": "Free Tailoring Training Center (Since 2018)",
    "free_tailoring_training_desc": "Offering free tailoring training for women to become self-reliant.",
    "free_it_training": "Free Computer Network Training (Since 2024)",
    "free_it_training_desc": "Providing free IT training to improve employment opportunities.",

    //aari form
    
      "formTitle": "Fill out the form below to enroll in our",
      "freeCourse": "Free Aari",
      "name": "Name",
      "gender": "Gender",
      "male": "Male",
      "female": "Female",
      "age": "Age",
      "address": "Address",
      "mobile": "Mobile Number",
      "education": "Education Qualification",
      "occupation": "Current Occupation",
      "timeSlot": "Preferred Training Time Slot",
      "parentSpouseName": "Parent/Spouse Name",
      "hasStartBusiness": "To start own business",
      "hasExperience": "Do you have prior Embroidery & Aari experience?",
      "hasExperienceTailor": "Do you have prior tailoring experience?",
      "aarireason":"Reason for joining the Embroidery & Aari course",
      "yes": "Yes",
      "no": "No",
      "submit": "Submit",
      "privacy": "I authorize AL INFAAQ Welfare Association to contact me with course updates via Email/SMS/WhatsApp/Call.",
      "success": "🎉 Registration successful! Our team will contact you soon.",
      "error": "⚠️ Registration failed. Please try again later.",
      "notification": "Notification",
      "ok": "OK",
    "tailoringreason":"Reason for joining the tailoring course",
    "dateOfBirth": "Date of Birth",
    "alternateNumber": "Alternate Mobile Number",
    "email": "Email",
    "experience": "Experience",
    "graduationYear": "Graduation Year",
      },

     
    },
    ta: {
      translation: {
        "AboutUsTitle": "உதவியவர்களுக்கு அல்லாஹ் உதவுவான்",
        "AboutUsContent": "Al-Infaaq Trust என்பது 2016 ஆம் ஆண்டில் ஆரம்பிக்கப்பட்டது, சமூகத்தில் பொருளாதார ரீதியாக பின் தங்கியுள்ள குடும்பங்களை அடையாளம் காண்ந்து, அவர்களுக்கு தேவையான உதவிகளை வழங்கும் நோக்குடன் செயல்படுகிறது. ஒரே ஒரு குடும்பத்துடன் தொடங்கிய இந்த நற்செயல், இன்று 30+ குடும்பங்களுக்கு உதவியாக வளர்ந்துள்ளது.",
        "OurMission": "எங்கள் நோக்கம்",
        "Mission1": "ஆதரவற்ற குடும்பங்களுக்கு <b>அத்தியாவசிய உதவிகள்</b> வழங்குதல்.",
        "Mission2": "பெண்களுக்கு <b>சுயதொழில் பயிற்சி</b> மற்றும் <b>பணிபல வாய்ப்புகளை</b> உருவாக்குதல்.",
        "Mission3": "மாணவர்களுக்கு <b>தகவல் தொழில்நுட்ப (IT) கல்வி</b> பயிற்சிகளை வழங்குதல்.",
        "ReadMore": "மேலும் படிக்க ▶",
        "Notices": "அறிவிப்புகள்",
        "TailoringCourse": "👗 தையல் பயிற்சி",
        "EmbroideryCourse": "🧵 எம்பிராய்டரி & ஆரி வேலை",
        "SoftwareCourse": "💻 சாப்ட்வேர் டெவலப்மெண்ட் கோர்ஸ்",
        "OngoingRegistrations": "நடப்பு பதிவுகள்",
        "TailoringDetails": "கைத்தொழில் பயிற்சியுடன் தொழில்முறை தையல் நுட்பங்களை கற்றுக்கொள்ளுங்கள்.",
        "EmbroideryDetails": "பாரம்பரிய வடிவமைப்புகளுக்கான எம்பிராய்டரி மற்றும் ஆரி வேலை நுட்பங்களை கற்றுக்கொள்ளுங்கள்.",
        "services_support": "சேவைகள் மற்றும் ஆதரவு",
        "monthly_essentials": "மாதாந்திர அத்தியாவசிய பொருட்கள்",
        "monthly_essentials_desc": "நாம் 30 க்கும் மேற்பட்ட குடும்பங்களுக்கு மாதந்தோறும் அவர்கள் குடும்பத்திற்கு தேவையான மளிகை பொருட்களை கொடுத்து வருகிறோம்.",
        "medical_education_fund": "மருத்துவம், கல்வி உதவித்தொகை",
        "medical_education_fund_desc": "நாம் பராமரிக்கும் குடும்பங்களுக்கு அவசர மருத்துவச் செலவுகள், கல்விக்கான ஆதரவு, மற்றும் மாணவர்களுக்கு உதவித்தொகை வழங்கி, அவர்களின் நல்லதிர்கால வளர்ச்சிக்கு துணையாக இருக்கிறோம்.",
        "self_employment_support": "சுய தொழில் உதவி",
        "self_employment_support_desc": "நாம் பராமரிக்கும் குடும்பங்களில் சுய தொழில் செய்ய விரும்புவோருக்கு சுய தொழிலும் ஏற்படுத்தி கொடுக்கின்றோம். பொது மக்களுக்கு உதவும் வகையில் அரசு நல திட்டங்கள் முகாம்கள் நடத்தி அவர்களுக்கு ஆன்லைன் ல் (online) விண்ணப்பித்து கொடுக்கின்றோம்.",
        "scholarship_assistance": "உதவித்தொகை (Scholarship)",
        "scholarship_assistance_desc": "மாணவ,மாணவிகளுக்கு அரசு மற்றும் தனியார் நிறுவங்கள் வழங்கும் உதவி தொகை (scholarship) கிடைக்கும் வகையில் முகாம்கள் நடத்தி அவர்களுக்கு விண்ணப்பித்து கொடுக்கின்றோம்.",
        /***about us  */
        "about_us": "எங்களைப் பற்றி",
        "a_little_insight": "சிறிய அறிமுகம்",
        "about_us_heading": "எங்களைப் பற்றிய சிறிய அறிமுகம்.",
        "about_us_content": "Al-Infaaq Trust 2016 ஆம் ஆண்டு உருவாக்கப்பட்டது. பொருளாதார ரீதியாக பின்தங்கிய குடும்பங்களை அடையாளம் காணும் நோக்கில் உருவாக்கப்பட்ட இந்த அறக்கட்டளை, அவர்களுக்கு தேவையான உதவிகளை வழங்குகிறது. ஒரே ஒரு குடும்பத்துடன் தொடங்கிய இந்த முயற்சி இன்று 30+ குடும்பங்களுக்கு ஆதரவாக இருக்கிறது.",
        "our_mission": "எங்கள் நோக்கம்",
        "mission_1": "பின்தங்கிய குடும்பங்களுக்கு அத்தியாவசிய உதவிகளை வழங்குதல்.",
        "mission_2": "பெண்களுக்கான சுயதொழில் பயிற்சி மற்றும் வேலை வாய்ப்புகளை உருவாக்குதல்.",
        "mission_3": "மாணவர்களுக்கு தகவல் தொழில்நுட்ப (IT) கல்வி பயிற்சி வழங்குதல்.",
        "activity": "செயல்பாடுகள்",
        "family_assistance": "குடும்ப உதவி",
        "education": "கல்வி",
        "housing": "வீட்டு வசதி",
        "social_help": "சமூக உதவி",
        "vocational_training": "தொழில் பயிற்சி",
        "donation": "நன்கொடை",
        "activity_description": "{{activity}} தேவையுடையோருக்கு வழங்கப்படும்.",
        "elevate_lives": "வாழ்க்கையை உயர்த்துங்கள், சிறந்த எதிர்காலத்தை உருவாக்குங்கள்",
        "donate_today": "இன்று நன்கொடை வழங்குங்கள்!",
        "donate_now": "நன்கொடை வழங்கு",
        /**courses */
        "courses": {
          "heading": "திறன் வளர்ச்சி பயிற்சிகள்",
          "subheading": "எங்கள் இலவச பயிற்சி மற்றும் கல்வி வகுப்புகள்",
          "register": "இப்போது பதிவு செய்யவும்",
          "tailoring": {
            "title": "தையல் பயிலகம்",
            "description": "பெண்களுக்கு தையல் கற்றுத் தரும் இப்பயிற்சி, சுயதொழிலுக்கான முதன்மையான படியாக விளங்கும். இந்த வகுப்புகள் மூலம், பெண்கள் தன்னம்பிக்கையுடன் சுயதொழிலில் ஈடுபடலாம்."
          },
          "embroidery": {
            "title": "எம்பிராய்டரி & ஆரி வேலை பயிற்சி",
            "description": "எம்பிராய்டரி & ஆரி வேலை வேலைப்பாடுகளில் திறமை வளர்த்து, தொழில்முனைவோராக உருவாக சிறந்த வாய்ப்பை வழங்கும். பெண்கள் தன்னம்பிக்கையுடன் முன்னேறலாம்."
          },
          "software": {
            "title": "சாப்ட்வேர் கோர்ஸ் பயிற்சி",
            "description": "மாணவர்கள் மற்றும் இளைஞர்களுக்கான அடிப்படை & மேம்பட்ட கணினி பயிற்சி, தொழில்நுட்ப உலகில் முன்னேறவும் கற்றுத் திறன் வளர்க்கவும் உதவும். இப்பயிற்சி வேலை வாய்ப்புகளை பெறவும், சுயதொழில் உருவாக்கவும் உதவுகிறது."
          }
        },
        /**service */
        "services_support": "சேவைகள் மற்றும் ஆதரவு",
    "monthly_essentials": "மாதந்தோறும் அத்தியாவசிய பொருட்கள்",
    "monthly_essentials_desc": "மாதந்தோறும் 30+ குடும்பங்களுக்கு மளிகைப் பொருட்கள் வழங்குதல்.",
    "helping_the_needy": "உதவிக்கோரர்களுக்கு உதவி",
    "helping_the_needy_desc": "மணவிலாக்கள், முதியவர்கள், வேலைஇல்லாதவர்கள், நோயாளிகள் மற்றும் விபத்துக்குள்ளானோருக்கு உதவி.",
    "medical_education_fund": "மருத்துவம் & கல்வி உதவி",
    "medical_education_fund_desc": "அவசர மருத்துவ செலவுகள், கல்விக்கான உதவிகள் மற்றும் மாணவர்களுக்கு உதவித்தொகை வழங்குதல்.",
    "self_employment_support": "சுய தொழில் உதவி",
    "self_employment_support_desc": "சுய தொழில் செய்ய விரும்புவோருக்கு உதவுதல், அரசு நலத்திட்டங்களுக்கு விண்ணப்பிக்க வழிகாட்டுதல்.",
    "scholarship_assistance": "உதவித்தொகை (Scholarship)",
    "scholarship_assistance_desc": "மாணவர்களுக்கு அரசு மற்றும் தனியார் உதவித்தொகைக்கு விண்ணப்பிக்க முகாம்கள் நடத்துதல்.",
    "government_welfare_awareness": "அரசு நலத்திட்ட விழிப்புணர்வு",
    "government_welfare_awareness_desc": "அரசு நலத்திட்டங்களை பற்றிய விழிப்புணர்வு நிகழ்ச்சிகள் நடத்தி, அதற்காக ஆன்லைனில் விண்ணப்பிக்க உதவுதல்.",
    "free_tailoring_training": "இலவச தையல் பயிற்சி மையம் (2018 முதல்)",
    "free_tailoring_training_desc": "பெண்கள் சுயதுன்பம் அடைய இலவச தையல் பயிற்சி வழங்குதல்.",
    "free_it_training": "இலவச கணினி நெட்வொர்க் பயிற்சி (2024 முதல்)",
    "free_it_training_desc": "வேலை வாய்ப்புகளை மேம்படுத்த இலவச தகவல் தொழில்நுட்ப (IT) பயிற்சி வழங்குதல்.",
    //aari form

    "formTitle": "தயவுசெய்து எங்கள் பயிற்சியில் சேர கீழே உள்ள படிவத்தை நிரப்பவும்",
    "freeCourse": "இலவச ஆரி",
    "name": "பெயர்",
    "gender": "பாலினம்",
    "male": "ஆண்",
    "female": "பெண்",
    "age": "வயது",
    "address": "முகவரி",
    "mobile": "மொபைல் எண்",
    "education": "படிப்பு",
    "occupation": "தொழில்",
    "timeSlot": "பயிற்சி நேரம்",
    "parentSpouseName": "தந்தை/கணவர் பெயர்",
    "hasStartBusiness": "சுய தொழில் செய்வதற்கு ",
    "aarireason":"எம்பிராய்டரி & ஆரி பயில காரணங்கள்",
    "hasExperience": "எம்பிராய்டரி & ஆரி ஒர்க் முன் அனுபவம் உண்டா",
    "hasExperienceTailor": "தையலில் முன் அனுபவம் உண்டா",
    "yes": "ஆம்",
    "no": "இல்லை",
    "submit": "சமர்ப்பிக்கவும்",
    "privacy": "என்னை தொடர்புகொள்வதற்கு ஏல்இன்ஃபாக் நல அமைப்பிற்கு அனுமதி அளிக்கிறேன்.",
    "success": "🎉 பதிவு வெற்றிகரமாக முடிந்தது! எங்கள் குழு விரைவில் தொடர்பு கொள்கிறது.",
    "error": "⚠️ பதிவு தோல்வி அடைந்தது. தயவுசெய்து பின்னர் முயற்சிக்கவும்.",
    "notification": "அறிவிப்பு",
    "ok": "சரி",
    "tailoringreason":"தையல் பயில காரணங்கள்",
"dateOfBirth": "பிறந்த தேதி",
"alternateNumber": "மாற்று மொபைல் எண்",
"email": "மின்னஞ்சல்",
"experience": "அனுபவம்",
"graduationYear": "பட்டம் பெற்ற ஆண்டு",
      },
    },
  },
  lng: "en", // Default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});



export default i18n;
